import instance, { ADMIN_PREFIX } from 'services/api';
import {
  AttachServiceDoctorsInput,
  ServiceDetail,
  ServiceInput,
  ServiceListQuery,
  ServiceListResponse,
  ServiceListRow
} from 'types/api/services';

/**
 * GET /api/v2/admin/content/services — PaginatedResponse envelope
 * ({data, total, page, limit, totalPages}); the FE consumer keeps the
 * legacy {results, total} shape so we map at the boundary. BE is 1-based,
 * FE callers are 0-based, so the service shifts.
 */
export const fetchServices = async (
  query: ServiceListQuery
): Promise<ServiceListResponse> => {
  const params: Record<string, string | number> = {
    page: query.page ?? 1,
    limit: query.limit ?? 10
  };

  if (query.name) params.name = query.name;
  if (query.lang) params.lang = query.lang;

  const res = await instance.get<{ data: ServiceListRow[]; total: number }>(
    `${ADMIN_PREFIX}/content/services`,
    { params }
  );

  return {
    results: res.data.data ?? [],
    total: res.data.total ?? 0
  };
};

export const fetchServiceById = async (
  id: string | number
): Promise<ServiceDetail> => {
  const res = await instance.get<ServiceDetail>(
    `${ADMIN_PREFIX}/content/services/${id}`
  );

  return res.data;
};

export const createService = (input: ServiceInput) =>
  instance.post<ServiceDetail>(`${ADMIN_PREFIX}/content/services`, input);

export const updateService = (id: string | number, input: ServiceInput) =>
  instance.put<ServiceDetail>(`${ADMIN_PREFIX}/content/services/${id}`, input);

export const deleteService = (id: string | number) =>
  instance.delete(`${ADMIN_PREFIX}/content/services/${id}`);

export const attachServiceToDoctors = (input: AttachServiceDoctorsInput) =>
  instance.post(`${ADMIN_PREFIX}/doctors-services/attach-service`, input);
